/* leapp redesign 2026 · gedrag. Geen afhankelijkheden. */
(function () {
  'use strict';
  var mqMobile = window.matchMedia('(max-width: 749px)');
  var mqTablet = window.matchMedia('(max-width: 989px)');

  /* Mobiel menu (dialog) */
  function initDrawer() {
    document.querySelectorAll('[data-l26-open]').forEach(function (btn) {
      if (btn.dataset.l26Bound) return;
      btn.dataset.l26Bound = '1';
      var dlg = document.getElementById(btn.getAttribute('data-l26-open'));
      if (!dlg || typeof dlg.showModal !== 'function') return;
      btn.addEventListener('click', function () {
        dlg.showModal();
        btn.setAttribute('aria-expanded', 'true');
      });
      dlg.addEventListener('close', function () {
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
      });
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) dlg.close();
      });
      dlg.querySelectorAll('[data-l26-close]').forEach(function (c) {
        c.addEventListener('click', function () { dlg.close(); });
      });
    });
  }

  /* Desktopmenu: submenu's openen met knop (toetsenbord en touch), hover via CSS */
  function initNav() {
    document.querySelectorAll('[data-l26-nav]').forEach(function (nav) {
      if (nav.dataset.l26Bound) return;
      nav.dataset.l26Bound = '1';
      var items = nav.querySelectorAll('.l26-nav__item--sub');
      function closeAll(except) {
        items.forEach(function (it) {
          if (it === except) return;
          it.classList.remove('is-open');
          var b = it.querySelector('.l26-nav__toggle');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
      }
      items.forEach(function (it) {
        var btn = it.querySelector('.l26-nav__toggle');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var open = !it.classList.contains('is-open');
          it.classList.remove('is-dismissed');
          closeAll(it);
          it.classList.toggle('is-open', open);
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        it.addEventListener('mouseleave', function () {
          it.classList.remove('is-dismissed');
          if (it.classList.contains('is-open') && !it.contains(document.activeElement)) {
            it.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false');
          }
        });
        it.addEventListener('focusout', function (e) {
          if (!it.contains(e.relatedTarget)) { it.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var open = nav.querySelector('.l26-nav__item--sub.is-open');
        nav.querySelectorAll('.l26-nav__item--sub:hover').forEach(function (h) { h.classList.add('is-dismissed'); });
        if (open) { closeAll(); var b = open.querySelector('.l26-nav__toggle'); if (b) b.focus(); }
      });
      document.addEventListener('click', function (e) { if (!nav.contains(e.target)) closeAll(); });
    });
  }

  /* Land/taal: direct versturen bij wijzigen */
  function initAutosubmit() {
    document.querySelectorAll('[data-l26-autosubmit]').forEach(function (sel) {
      if (sel.dataset.l26Bound) return;
      sel.dataset.l26Bound = '1';
      sel.addEventListener('change', function () { sel.form && sel.form.submit(); });
    });
  }

  /* Tabs met pijltjestoetsen */
  function initTabs() {
    document.querySelectorAll('[data-l26-tabs]').forEach(function (root) {
      if (root.dataset.l26Bound) return;
      root.dataset.l26Bound = '1';
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab, false); });
        tab.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (e.key === 'Home') n = tabs[0];
          if (e.key === 'End') n = tabs[tabs.length - 1];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
    });
  }

  /* Accordeons die alleen op mobiel dicht starten */
  function initMobileAccordions() {
    if (mqMobile.matches) {
      document.querySelectorAll('[data-l26-footacc]').forEach(function (d) {
        if (!d.dataset.l26Init) { d.open = false; d.dataset.l26Init = '1'; }
      });
    } else {
      document.querySelectorAll('[data-l26-footacc]').forEach(function (d) { d.open = true; });
    }
    document.querySelectorAll('[data-l26-mobacc]').forEach(function (d, i) {
      if (mqTablet.matches) {
        if (!d.dataset.l26Init) { d.open = i === 0; d.dataset.l26Init = '1'; }
      } else {
        d.open = true;
      }
    });
  }

  /* Inruilen Ja/Nee */
  function initTradeIn() {
    document.querySelectorAll('[data-l26-ti]').forEach(function (root) {
      if (root.dataset.l26Bound) return;
      root.dataset.l26Bound = '1';
      var yes = root.querySelector('[data-l26-ti-yes]');
      var no = root.querySelector('[data-l26-ti-no]');
      function press(btn) {
        [yes, no].forEach(function (b) { if (b) b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      }
      if (no) no.addEventListener('click', function () { press(no); });
      if (yes) {
        yes.addEventListener('click', function () {
          press(yes);
          /* Focus terug naar Ja zodra de pop-up van de inruil-app weer dicht is */
          var observer = new MutationObserver(function () {
            var a = document.activeElement;
            if (!a || a === document.body) {
              var modalOpen = document.querySelector('[class*="tradein"][class*="modal"], [id*="tradein"][id*="modal"], iframe[src*="tradein"]');
              if (!modalOpen) { yes.focus(); observer.disconnect(); }
            }
          });
          setTimeout(function () { observer.observe(document.body, { childList: true, subtree: false, attributes: true }); }, 400);
          setTimeout(function () { observer.disconnect(); }, 10 * 60 * 1000);
        });
      }
    });
  }

  /* Productpagina: prijs per optieknop (conditie, batterij), uitverkocht gestippeld, labels op foto, specs bijwerken */
  function enhanceProduct() {
    var dataEl = document.querySelector('script[data-l26-variants]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var names = (data.options || []).map(function (n) { return String(n); });
    var condNames = (data.condition_names || []).map(function (n) { return String(n).trim().toLowerCase(); });

    /* Alle opties die in "Optienamen voor conditie" staan krijgen prijzen. De eerste is de hoofdconditie. */
    var priceIdx = [];
    names.forEach(function (n, i) { if (condNames.indexOf(n.trim().toLowerCase()) > -1) priceIdx.push(i); });
    var condIndex = priceIdx.length ? priceIdx[0] : -1;

    var scope = dataEl.closest('.product-information') || document;
    var selected = names.map(function (name) {
      var checked = scope.querySelector('input[data-option-name="' + cssEscape(name) + '"]:checked');
      if (checked) return checked.value;
      var sel = scope.querySelector('select option[data-option-name="' + cssEscape(name) + '"]:checked');
      return sel ? sel.value : null;
    });
    var idInput = scope.querySelector('form input[name="id"]');
    var current = null;
    if (idInput) {
      data.variants.forEach(function (v) { if (String(v.id) === String(idInput.value)) current = v; });
    }
    if (current) selected = current.options.slice();

    function find(opts) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    priceIdx.forEach(function (idx) {
      var inputs = scope.querySelectorAll('input[data-option-name="' + cssEscape(names[idx]) + '"]');
      inputs.forEach(function (input) {
        var label = input.closest('.variant-option__button-label') || input.parentElement;
        if (!label) return;
        label.querySelectorAll('.l26-opt-price, .l26-opt-mail').forEach(function (n) { n.remove(); });
        label.classList.remove('l26-unavail');
        var opts = selected.slice();
        opts[idx] = input.value;
        var v = find(opts);
        if (v && v.ok) {
          var s = document.createElement('span');
          s.className = 'l26-opt-price';
          s.textContent = String(v.price).replace(/,00$/, '').replace(/\.00$/, '');
          label.appendChild(s);
        } else if (v) {
          label.classList.add('l26-unavail');
          if (data.soldout_url) {
            var a = document.createElement('a');
            a.className = 'l26-opt-mail';
            a.href = data.soldout_url;
            a.textContent = data.soldout_label || 'Mail me';
            a.addEventListener('click', function (e) { e.stopPropagation(); });
            label.appendChild(a);
          }
        }
      });

      /* Link "Bekijk de verschillen" alleen bij de hoofdconditie */
      if (idx === condIndex && data.diff_url && data.diff_label) {
        var fs = inputs.length ? inputs[0].closest('fieldset') : null;
        var legend = fs ? fs.querySelector('legend') : null;
        if (legend && !legend.querySelector('.l26-diff-link')) {
          var dl = document.createElement('a');
          dl.className = 'l26-diff-link';
          dl.href = data.diff_url;
          dl.textContent = data.diff_label;
          legend.appendChild(dl);
        }
      }
    });

    /* Labels op de fotogalerij
       Nieuwe batterij als:
       - een gekozen waarde een zoekterm bevat (iPhone: "Als nieuw + Nieuwe batterij"), of
       - de optienaam een zoekterm bevat en de gekozen waarde "nieuw" is (Samsung: "Kies je batterij" = "Nieuw") */
    var media = scope.querySelector('.product-information__media');
    if (media) {
      var chips = (data.chips || []).slice();
      var terms = String(data.battery_match || '').split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
      var batt = false;
      if (terms.length) {
        names.forEach(function (name, i) {
          var val = String(selected[i] || '').toLowerCase();
          var nm = name.toLowerCase();
          if (!val) return;
          terms.forEach(function (t) {
            if (val.indexOf(t) > -1) batt = true;
            if (nm.indexOf(t) > -1 && /^nieuw/.test(val)) batt = true;
          });
        });
      }
      var box = media.querySelector('.l26-gallery-chips');
      if (!box && (chips.length || batt)) {
        box = document.createElement('div');
        box.className = 'l26-gallery-chips';
        box.setAttribute('aria-hidden', 'true');
        if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
        media.appendChild(box);
      }
      if (box) {
        var html = chips.map(function (c) { return '<span>' + escapeHtml(c) + '</span>'; }).join('');
        if (batt && data.battery_chip) html += '<span class="l26-dark">' + escapeHtml(data.battery_chip) + '</span>';
        if (box.innerHTML !== html) box.innerHTML = html;
      }
    }

    /* Specificaties onder de vouw volgen de gekozen variant */
    document.querySelectorAll('[data-l26-opt]').forEach(function (dd) {
      var i = parseInt(dd.getAttribute('data-l26-opt'), 10);
      if (!isNaN(i) && selected[i] && dd.textContent !== selected[i]) dd.textContent = selected[i];
    });
  }

  function watchProduct() {
    var section = document.querySelector('.product-information');
    if (!section) return;
    enhanceProduct();
    var t = null, busy = false;
    new MutationObserver(function () {
      if (busy) return;
      clearTimeout(t);
      t = setTimeout(function () { busy = true; enhanceProduct(); initTradeIn(); setTimeout(function () { busy = false; }, 50); }, 60);
    }).observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked', 'value'] });
    section.addEventListener('change', function () { setTimeout(enhanceProduct, 30); });
  }

  /* Blog: inhoudsopgave, verplaatsen van widget en producten, vaste balk */
  function initArticle() {
    var art = document.querySelector('[data-l26-article]');
    if (!art) return;
    var content = art.querySelector('[data-l26-content]');
    var h2s = content ? Array.prototype.slice.call(content.querySelectorAll('h2')) : [];

    art.querySelectorAll('[data-l26-move-after-h2]').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-l26-move-after-h2'), 10);
      if (n > 0 && h2s[n - 1]) h2s[n - 1].parentNode.insertBefore(el, h2s[n - 1]);
    });

    var heads = Array.prototype.slice.call(art.querySelectorAll('.l26-takeaways__title, [data-l26-content] h2, #veelgestelde-vragen'));
    var used = {};
    var items = heads.map(function (h) {
      if (!h.id) {
        var base = (h.textContent || 'sectie').toLowerCase().trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'sectie';
        var id = base, k = 2;
        while (used[id] || document.getElementById(id)) { id = base + '-' + k++; }
        h.id = id;
      }
      used[h.id] = true;
      return { id: h.id, text: h.textContent.trim(), el: h };
    });
    if (items.length >= 2) {
      art.querySelectorAll('[data-l26-toc-list]').forEach(function (list) {
        list.innerHTML = items.map(function (it) { return '<li><a href="#' + it.id + '">' + escapeHtml(it.text) + '</a></li>'; }).join('');
      });
      art.querySelectorAll('[data-l26-toc], [data-l26-toc-mobile]').forEach(function (n) { n.hidden = false; });
      if ('IntersectionObserver' in window) {
        var links = art.querySelectorAll('[data-l26-toc] a');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            links.forEach(function (a) { a.setAttribute('aria-current', a.getAttribute('href') === '#' + e.target.id ? 'true' : 'false'); });
          });
        }, { rootMargin: '0px 0px -70% 0px' });
        items.forEach(function (it) { io.observe(it.el); });
      }
    }

    var bar = document.querySelector('[data-l26-stickybar]');
    if (bar) {
      var onScroll = function () { bar.hidden = window.scrollY < 600; };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  function cssEscape(s) { return window.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/"/g, '\\"'); }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function init() {
    initDrawer();
    initNav();
    initAutosubmit();
    initTabs();
    initMobileAccordions();
    initTradeIn();
    initArticle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); watchProduct(); });
  } else { init(); watchProduct(); }

  /* Theme editor: opnieuw koppelen na wijzigingen */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();